import React from 'react';
import { Chip } from '@mui/material';
import { ChargerStatus } from '../services/chargerService';

interface ChargerStatusChipProps {
  status: ChargerStatus;
  size?: 'small' | 'medium';
}

export const ChargerStatusChip: React.FC<ChargerStatusChipProps> = ({ status, size = 'small' }) => {
  const getStatusColor = (status: ChargerStatus) => {
    switch (status) {
      case ChargerStatus.ACTIVE:
        return 'success';
      case ChargerStatus.IN_STORAGE:
        return 'default';
      case ChargerStatus.UNDER_REPAIR:
        return 'warning';
      case ChargerStatus.DAMAGED:
        return 'error';
      case ChargerStatus.RETIRED:
        return 'default';
      default:
        return 'default';
    }
  };

  const getStatusLabel = (status: ChargerStatus) => {
    switch (status) {
      case ChargerStatus.ACTIVE:
        return 'Active';
      case ChargerStatus.IN_STORAGE:
        return 'In Storage';
      case ChargerStatus.UNDER_REPAIR:
        return 'Under Repair';
      case ChargerStatus.DAMAGED:
        return 'Damaged';
      case ChargerStatus.RETIRED:
        return 'Retired';
      default:
        return status;
    }
  };

  return (
    <Chip
      label={getStatusLabel(status)}
      color={getStatusColor(status) as any}
      size={size}
      variant={status === ChargerStatus.RETIRED ? 'outlined' : 'filled'}
    />
  );
};
